import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import Map from 'ol/Map';
import View from 'ol/View';
import * as olProj from 'ol/proj';
import Feature from 'ol/Feature';
import OSM from 'ol/source/OSM';
import { Point } from "ol/geom";
import { BingMaps, Cluster, Vector, XYZ } from "ol/source";
import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import { Tile } from "ol/layer";
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import "ol/ol.css";
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
import TileLayer from 'ol/layer/Tile';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';

declare let $: any;


@Component({
  selector: 'app-emdadran-search',
  templateUrl: './emdadran-search.component.html',
  styleUrls: ['./emdadran-search.component.css']
})

export class EmdadranSearchComponent implements OnInit {
  lst_Trips: any[] = [];
  lst_Search: any = [];
  iFinalRent: number = 0;
  iCommission: number = 0;
  iDebitCredit: number = 0;
  bMap: boolean = false;
  isCity: boolean = false;
  showFilter: boolean = false;
  bEditMode: boolean | 'showMode' | 'searchMode' = false;
  list_MobileType: any[] = [];
  list_MobileGroup: any[] = [];
  list_Reason: any[] = [];
  list_ReliefType: any[] = [];
  list_Driver: any[] = [];
  list_TripStatus: any[] = [];
  list_SystemUser: any[] = [];
  lst_City: any = [];
  lst_GroupCar: any = [];
  map: any = {};
  acssess: any;
  source: any;
  vector: any;
  layers: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;
  private strMapUrl: string = (<any>window).strMapUrl;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(moment().subtract(30, 'day').format('jYYYY/jMM/jDD')),

    strEDate: new FormControl(''),

    strUnitID: new FormControl(''),

    tiTripStatus: new FormControl(-1),

    iSystemUser_User: new FormControl(-1),

    bNonCorporate: new FormControl(false),

  })

  mdl_TripSAD: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iEmdadRo: new FormControl(''), //  نام مسافر

    strName: new FormControl(''), //  نام مسافر

    strFamily: new FormControl('', Validators.required), //  فامیل مسافر 

    strMobile: new FormControl('', Validators.required), //  موبایل مسافر

    tiMobileType: new FormControl('-1', Validators.required), // نوع خودرو 

    tiReason4Request: new FormControl('-1', Validators.required), // علت درخواست 

    tiReliefRequestType: new FormControl('-1', Validators.required), // نوع درخواست امداد 

    strReasonStopping: new FormControl(''), // دلیل توقف   

    tiMobileGroup: new FormControl('', Validators.required), // نوع جرثقیل 

    strSCity: new FormControl('', Validators.required), // شهر مبدا

    strSAddress: new FormControl('', Validators.required), // آدرس مبداء

    fSLat: new FormControl(0, Validators.required), // موقعیت مبدا

    fSLon: new FormControl(0, Validators.required), // موقعیت مبدا

    strDCity: new FormControl(''), // شهر مقصد

    strDAddress: new FormControl(''), // آدرس مقصد

    fDLat: new FormControl(0), // موقعیت مقصد

    fDLon: new FormControl(0), // موقعیت مقصد

    strDate: new FormControl('', Validators.required), // تاریخ

    strTime: new FormControl('', Validators.required), // ساعت

    bTraffic: new FormControl(false), // چک باکس طرح ترافیک

    bEvenOdd: new FormControl(false), // چک باکس طرح آلودگی 

    bBadWeather: new FormControl(false), // چک باکس شرایط آب وهوایی ویژه 

    bMountainous: new FormControl(false), // چک باکس منطقه کوهستانی 

    strComment: new FormControl(''), // توضیحات

    strVehicleNo: new FormControl(''), // پلاک

    strVehicleNo_1: new FormControl(''),

    strVehicleNo_2: new FormControl(''),

    strVehicleNo_3: new FormControl(''),

    strVehicleNo_4: new FormControl(''),

    iFixCost: new FormControl(0, Validators.required), //  کرایه اعلام شده

    iPartnerRent: new FormControl(0), //  کرایه اعلام شده

    iPartnerReceived: new FormControl(0), //  کرایه دریافت شده

    fEstimateKm: new FormControl(''), //  مسافت

    _fKm: new FormControl(''), //  مسافت

    _strTime: new FormControl(''), //  مدت زمان سفر

    _index: new FormControl(''), // 

  });

  mdl_Request: FormGroup = this.FormBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
    iTaxiLon_Trip: new FormControl(''),
    strName: new FormControl('', Validators.required), //  نام مسافر
    strFamily: new FormControl('', Validators.required), //  فامیل مسافر 
    strMobile: new FormControl('', Validators.required), //  موبایل مسافر
    tiSex: new FormControl(1, Validators.required), //  جنسیت 
    strID: new FormControl(''), //  کد ملی
    bForAnother: new FormControl(false), //  برای دیگری
    strPassengersName: new FormControl(''), //  نام مسافر دیگر
    strDate: new FormControl('', Validators.required), //  تاریخ سفر
    strTime: new FormControl('', Validators.required), //  ساعت سفر
    strSCity: new FormControl('', Validators.required), //  شهر مبدا
    fSLon: new FormControl('', Validators.required),
    fSLat: new FormControl('', Validators.required),
    strSAddress: new FormControl('', Validators.required),
    strDCity: new FormControl('', Validators.required), //  شهر مقصد
    fDLon: new FormControl('0'),
    fDLat: new FormControl('0'),
    strDAddress: new FormControl(''),
    bCameBack: new FormControl(false), //  دارای برگشت 
    bHasStop: new FormControl(false), //  داری توقف
    fEstimateStop: new FormControl(''), //  مدت توقف مثلا 3.5 ساعت 
    tiPassenger: new FormControl(1), //  تعداد مسافر
    bCargo: new FormControl(false), //  بار دارد
    strCargoDetail: new FormControl(''), //  توضیحات بار
    bPet: new FormControl(false), //  حیوان خانگی 
    bSmoking: new FormControl(false), //  سیگار مجاز
    bNeedHelp: new FormControl(false), //  نیاز به کمک 
    bInvoiceRequired: new FormControl(false), //  نیاز به فاکتور
    strCompany: new FormControl(''), //  اسم شرکت برای فاکتور
    bForeigner: new FormControl(false), //  مسافر غیر ایرانی
    strPassportNumber: new FormControl(''), //  شماره پاسپورت مسافر غیر ایرانی 
    strComment: new FormControl(''), //  توضیحات
    tiMobileGroup: new FormControl('', Validators.required), //  گروه خودرویی
    iEstimateRent: new FormControl(0, Validators.required), //  کرایه
    strUnitID: new FormControl(''), // شناسه خودرو
    strDriver_FullName: new FormControl(''), // نام راننده
    strDriver_Mobile: new FormControl(''), // موبایل راننده
    fEstimateKm: new FormControl(''), //  مسافت
    tiCommissionPercentage: new FormControl(''), //  درصد کمیسیون
    iAdvancePayment: new FormControl(''), //  مقدار پیش پرداخت
    _fKm: new FormControl(''), //  مسافت
    _strTime: new FormControl(''), //  مدت زمان سفر
    _index: new FormControl('-1')

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  ngOnInit(): void {

    var data = window.localStorage.getItem("menu") as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

    this.route.url.subscribe((segment: any) => {

      if (segment[1]?.path == 'map') {

        this.bMap = true;

        setTimeout(() => {

          this.source = new VectorSource({ wrapX: false });

          this.vector = new VectorLayer({

            source: this.source,

          });

          if (this.bOfflineMap) {

            this.layers.push(

              new TileLayer({

                source: new XYZ({

                  url: this.strMapUrl,

                  attributions: 'Map data © RayanAndishehNasr' // 

                }),

              })

            );
          }

          else {

            const styles = [

              'AerialWithLabelsOnDemand',

            ];

            let i, ii;

            for (i = 0, ii = styles.length; i < ii; ++i) {
              this.layers.push(
                new TileLayer({
                  visible: false,
                  preload: Infinity,
                  source: new BingMaps({
                    key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                    imagerySet: styles[i],
                  }),

                }),
              );
            }

            this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
          }

          this.map = new Map({

            target: "test2",

            view: new View({

              zoom: 14,

              center: olProj.fromLonLat([51.3833554, 35.6770113])

            }),

            layers: this.layers

          });

        }, 300);

        setTimeout(() => {

          this.lst_Trips = JSON.parse(this.gurdService.decrypt(localStorage.getItem('x5SBJaw')!));

          this.clustersLayer(this.lst_Trips);

        }, 500)


      }

    });

    this.getMobileGroup();

    this.city_TaxiLon();

  }

  async search_Trip() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`EmdadRo_ORG_Search`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Trips = res;

    this.lst_Search = res;

    this.iFinalRent = 0;

    this.iCommission = 0;

    this.iDebitCredit = 0;

    this.lst_Trips.forEach((el: any) => {

      this.iFinalRent += el.iFinalRent;

      this.iCommission += el.iCommission;

      this.iDebitCredit += el.iDebitCredit;

    })

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  filter_list(val: any) {

    this.lst_Trips = this.lst_Search.filter((el: any) => {

      return el?.strSystemUser_FullName?.includes(val.value) ||

        el.iEmdadRo?.toString().includes(val.value) ||

        el.strTaxiLon_TripStatus_strComment?.toString().includes(val.value) ||

        el.strSCityName?.includes(val.value) ||

        el.strFullName?.includes(val.value) ||

        el.strMobile?.includes(val.value) ||

        el.strDriver_Mobile?.includes(val.value) ||

        el.strDriver_FullName?.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Trips = this.lst_Search;

    }

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'جستجوی سفر.xlsx');
  }

  showMap() {

    if (!this.lst_Trips.length) return this._tooltip.showError('نتیجه ایی یافت نشد!');
    window.localStorage.removeItem('x5SBJaw');

    const encryptedTrips = this.gurdService.encrypt(JSON.stringify(this.lst_Trips))
    window.localStorage.setItem("x5SBJaw", encryptedTrips);

    const urlTree = this.router.createUrlTree(['emdadran', 'search-requests', 'map']);
    const serializedUrl = this.router.serializeUrl(urlTree);
    window.open(serializedUrl, '_blank');

  }

  clustersLayer(data: any) {

    setTimeout(() => {

      this.map.on('click', (e: any) => {

        if (e.dragging) return;

        var el = this.mapService.mapPointerMove(

          this.map.getEventPixel(e.originalEvent),

          this.map

        );

        this.showData(el);

      });

    }, 200);

    var clusterSource = new Cluster({

      distance: 40,

      source: new Vector()

    }) as any;


    let addFeatures = (nb: any) => {

      var ext = this.map.getView().calculateExtent(this.map.getSize());

      var features = [];

      for (var i = 0; i < data.length; ++i) {

        features[i] = new Feature({

          type: 'removable',

          geometry: new Point(this.mapService.transformCoordinates2([data[i]?.fSLon || data[i]?.fLon, data[i]?.fSLat || data[i]?.fLat])),

          id_: data[i]?.strUnitID || data[i]?.iPreregistration,

          data: { index: i, Id: data[i].strUnitID || data[i]?.iPreregistration, ...data[i] },

        });

        features[i].set("id", i);

      }

      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);

    }

    var styleCache = {} as any;

    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });

    this.map.addLayer(clusterLayer);

    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });

    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });

    this.map.addInteraction(selectCluster);

    this.fitMapArray(data);

  }

  fitMapArray(data: any) {

    data = data.filter(function (el: any) {

      return (el?.fSLon != 0 || el?.fLon != 0);

    });

    var maxLatitude = Math.max.apply(Math,

      data.map(function (o: any) {

        return (o?.fSLat || o?.fLat);

      })

    );

    var maxLongitude = Math.max.apply(Math,

      data.map(function (o: any) {

        return (o?.fSLon || o?.fLon);

      })

    );

    var minLatitude = Math.min.apply(Math,

      data.map(function (o: any) {

        return (o?.fSLat || o?.fLat);

      })

    );

    var minLongitude = Math.min.apply(Math,

      data.map(function (o: any) {

        return (o?.fSLon || o?.fLon);

      })

    );

    var view = this.map.getView();

    var transformedStart = this.mapService.transformCoordinates2([

      maxLongitude + (data.length > 1 ? 4 : 0),

      maxLatitude + (data.length > 1 ? 4 : 0),

    ]);

    var transformedEnd = this.mapService.transformCoordinates2([

      minLongitude - (data.length > 1 ? 4 : 0),

      minLatitude - (data.length > 1 ? 4 : 0),

    ]);

    var source = [

      Math.min(transformedStart[0], transformedEnd[0]) - 6000,

      Math.min(transformedStart[1], transformedEnd[1]) - 6000,

      Math.max(transformedStart[0], transformedEnd[0]) + 6000,

      Math.max(transformedStart[1], transformedEnd[1]) + 6000,



    ];

    view.fit(source);

    if (data.length == 1) {

      this.map.getView().setZoom(14);

    }


  }

  showTripRoute(item: any) {

    if (item.tiTripStatus < 4 || item.tiTripStatus > 8) return this._tooltip.showError('امکان مشاهده مسیر وجود ندارد!')

    window.open(`route/${item.strUnitID}`, '_blank')

    window.localStorage.setItem("RouteDate", this.gurdService.encrypt(item.strDate));

    window.localStorage.setItem("reportStime", this.gurdService.encrypt(item.strSTripTime));

    window.localStorage.setItem("reportEtime", this.gurdService.encrypt(item.strETripTime));

    window.localStorage.setItem("UnitID", this.gurdService.encrypt(item.strUnitID.toString()));

    window.localStorage.setItem("carName", this.gurdService.encrypt(item.strFullName.toString()));

    window.localStorage.setItem("plate", this.gurdService.encrypt(item.strVehicleNo.toString()));

  }

  newRequest(item: any = {}, index: number = -1, mode: 'showMode') {

    if (item?.iEmdadRo) {

      Object.keys(item).forEach((key) => {

        this.mdl_TripSAD.get(key)?.setValue(typeof (item[key]) == 'boolean' ? item[key] : item[key].toString());

      })

      this.mdl_TripSAD.patchValue({

        strVehicleNo_1: item.strVehicleNo.split(' ')[0],

        strVehicleNo_2: item.strVehicleNo.split(' ')[1],

        strVehicleNo_3: item.strVehicleNo.split(' ')[2],

        strVehicleNo_4: item.strVehicleNo.split(' ')[4],

      })

      this.mdl_TripSAD.get('_index')?.setValue(index);

      this.bEditMode = mode;

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#newEmdad_Modal").modal("show");

    }

  }

  newRequest_2(item: any = {}, index: number = -1, mode?: 'showMode') {

    if (item?.iTaxiLon_Trip) {

      Object.keys(item).forEach((key) => {

        this.mdl_Request.get(key)?.setValue(item[key]);

      })

      this.mdl_Request.get('_index')?.setValue(index);

      this.mdl_Request.get('_fKm')?.setValue('');

      this.mdl_Request.get('_strTime')?.setValue('');

      this.bEditMode = mode ? 'showMode' : true;

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#newReq_Modal").modal("show");

    }

  }

  getMobileGroup = async () => {

    this._otherService.Showspinner();

    let res = (await axios.post(`GetMobileType`, {})).data;

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.list_MobileType = res;

    // ---------------------------------------------------------------

    let res_2 = JSON.parse((await axios.post(`GetMobileGroup`)).data);

    if (res_2.bError || res_2.iResult == 0) return this._tooltip.showError(res_2.strError);

    this.list_MobileGroup = res_2;

    // ---------------------------------------------------------------

    let res_3 = JSON.parse((await axios.post(`Reason4Request`)).data);

    if (res_3.bError || res_3.iResult == 0) return this._tooltip.showError(res_3.strError);

    this.list_Reason = res_3;

    // ------------------------------------------------------------------------

    let res_4 = JSON.parse((await axios.post(`ReliefRequestType`)).data);

    this._otherService.nonespinner();

    if (res_4.bError || res_4.iResult == 0) return this._tooltip.showError(res_4.strError);

    this.list_ReliefType = res_4;

    // ------------------------------------------------------------------------

    let res_5 = JSON.parse((await axios.post(`Peysepar_Mobile_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    if (res_5.bError || res_5.iResult == 0) return this._tooltip.showError(res_5.strError);

    this.list_Driver = res_5;

    // ------------------------------------------------------------------------

    let res_6 = JSON.parse((await axios.post(`TaxiLon_TripStatus_list`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    if (res_6.bError || res_6.iResult == 0) return this._tooltip.showError(res_6.strError);

    this.list_TripStatus = res_6;

    // ------------------------------------------------------------------------

    let res_7 = JSON.parse((await axios.post(`TaxiLon_SystemUser_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res_7.bError || res_7.iResult == 0) return this._tooltip.showError(res_7.strError);

    this.list_SystemUser = res_7;


  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  city_TaxiLon = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_City_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_City = res;


    // ------------------------------------------------------------- >

    this._otherService.Showspinner();

    const resp = await axios.post(`GetMobileGroup`, {});

    resp.data = JSON.parse(resp.data);

    this._otherService.nonespinner();

    if (resp.data.bError || resp.data.iResult == 0) return this._tooltip.showError(resp.data.strError);

    this.lst_GroupCar = resp.data;



  }

  showData(item: any) {

    if (item.featureLayer) {

      if (item.featureLayer.feature) {

        if (item.featureLayer.feature.values_.features.length == 1) {

          let clicked_data = item.featureLayer.feature.values_.features[0].values_.data;

          if (clicked_data.iEmdadRo) {

            this.newRequest(clicked_data, clicked_data.index, 'showMode');

          }

          else if (clicked_data.iTaxiLon_Trip) {

            this.newRequest_2(clicked_data, clicked_data.index, 'showMode');

          }

        }

      }

    }

  }

  putSeprator(number: number | string, mode: 'showMode' | 'searchMode' | boolean): string | number {

    if (mode == 'showMode' || mode) {

      return number.toLocaleString();

    }

    else {
      return number
    }

  }

  accessibility(...array: string[]): boolean {

    let result = false;

    for (let i = 0; i < array.length; i++) {

      if (this.acssess[array[i]] == true && !result) {

        result = true;

        break;

      }

    }

    return result;

  }

}
